import { useSignal } from "./use-signal";

// Use a Symbol for better encapsulation and to avoid naming conflicts
const SECTION_MENTION_SIGNAL = Symbol("section-mention");
const RANGE_MENTION_SIGNAL = Symbol("range-mention");

export function useSectionMentionSignal() {
  return useSignal<{ id: string; label: string }>(SECTION_MENTION_SIGNAL);
}

export function useRangeMentionSignal() {
  return useSignal<{ from: number; to: number }>(RANGE_MENTION_SIGNAL);
}
